<script lang="ts">
  import type { SecurityFinding } from "$lib/stores/orgSecurityFindings";
  import { formatNumberWithAbbreviation } from "$lib/utils/number";
  import { sumBy } from "lodash";
  const { findings } = $props<{ findings: SecurityFinding[] }>();

  const stats = $state({
    numberOfMisconfiguredPermissions: 0,
    totalNumberOfFindings: 0,
  });

  $effect(() => {
    console.log("[FindingStatsCard] ** Computing stats **", findings.length);
    const startTime = performance.now();
    const numberOfMisconfiguredPermissions = sumBy(findings, "numberOfMisconfiguredPermissions");
    const endTime = performance.now();
    console.log("[FindingStatsCard] ** Time taken **", endTime - startTime);
    const totalNumberOfFindings = findings.length;
    stats.numberOfMisconfiguredPermissions = numberOfMisconfiguredPermissions;
    stats.totalNumberOfFindings = totalNumberOfFindings;
  });
</script>

<div class="col-span-1 row-span-1 bg-white rounded-lg shadow h-full flex flex-col">
  <div class="px-4 py-3 sm:px-6 sm:py-5">
    <h2 class="font-bold text-base text-gray-500">Detected Issues Overview</h2>
  </div>

  <div class="px-3 sm:px-6 pt-1 pb-3 flex flex-col gap-3 sm:gap-4 flex-1">
    <!-- Findings stat -->
    <div class="bg-gray-50 rounded-lg p-3 sm:p-4 text-center">
      <div class="text-2xl sm:text-3xl font-bold text-blue-600">
        {formatNumberWithAbbreviation(stats.totalNumberOfFindings)}
      </div>
      <div class="text-xs sm:text-sm text-gray-600 mt-1">Total Issues Detected</div>
    </div>

    <!-- Misconfigured Permission stats -->
    <div class="text-center bg-gray-50 rounded-lg p-3 sm:p-4">
      <div class="text-2xl sm:text-3xl font-bold text-red-500">
        {formatNumberWithAbbreviation(stats.numberOfMisconfiguredPermissions)}
      </div>
      <div class="text-xs sm:text-sm text-gray-600 mt-1">Misconfigured Permissions</div>
    </div>
  </div>
</div>
